import Collection from 'core/model/Collection';
import GlobalFilterModel from './GlobalFilterModel';

class GlobalFilterCollection extends Collection {
  get url() {
    return '/api/ui/rbux/scopes';
  }

  get model() {
    return GlobalFilterModel;
  }

  get defaultSortState() {
    return {
      field: 'name',
      direction: 'asc'
    };
  }

  get filterFieldWhitelist() {
    return new Set(['name', 'description']);
  }
}

export default GlobalFilterCollection;
